(function ($) {
  $(document).ready(function () {
    if ($(".full-width-video-with-slider").length > 0) {
      setTimeout(function () {
        $(".full-width-video-with-slider .slide-wrapper").css({ opacity: "1" });
      }, 500);

      $(".full-width-video-with-slider .slide-wrapper").slick({
        infinite: false,
        slidesToShow: 1,
        slideToScroll: 1,
        dots: false,
        arrows: true,
        prevArrow: $(".full-width-video-with-slider .slick-prev"),
        nextArrow: $(".full-width-video-with-slider .slick-next"),
      });
      //    $('.full-width-video-with-slider .slide').css('opacity','1');
    }

    $(".full-width-video .column-wrapper a span").hover(
      function () {
        $(".full-width-video .column-wrapper .bg-img").addClass("zoom");
      },
      function () {
        $(".full-width-video .column-wrapper .bg-img").removeClass("zoom");
      }
    );
    
  });
})(jQuery);
